export default {
  state: {
    orginalFilter: null,
    editedFilter: null
  },
  mutations: {
    setOriginalFilter (state, value) { state.orginalFilter = value },
    setEditedFilter (state, value) { state.editedFilter = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/filters/filter-details.js